import React, { useState } from 'react';
import { Box, TextField, Button, Typography, Link, } from '@mui/material';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../../../firebase/firebaseConfig';
import { useNavigate } from 'react-router-dom';
import Alerta from '../../../components/Alerta';

const Login = () => {
    const navigate = useNavigate();
    // Manejo de los valores de los campos del formulario
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [estadoAlerta, cambiarEstadoAlerta] = useState(false);
	const [alerta, cambiarAlerta] = useState({});

    const handleChange = (e) => {
		if(e.target.name === 'email'){
			setEmail(e.target.value);
		} else if (e.target.name === 'password'){
			setPassword(e.target.value);
		}
	}

    const handleSubmit = async (e) => {
        e.preventDefault();
        cambiarEstadoAlerta(false);
        cambiarAlerta({});

        // Comprobamos del lado del cliente que el correo sea valido.
        const expresionRegular = /[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+/;
        if( !expresionRegular.test(email) ){
            cambiarEstadoAlerta(true);
            cambiarAlerta({
                tipo: 'error',
                mensaje: 'Por ingresa un correo electrónico valido'
            });
            return;
        }

        if(email === '' || password === ''){
            cambiarEstadoAlerta(true);
            cambiarAlerta({
                tipo: 'error',
                mensaje: 'Por favor rellena todos los datos'
            });
            return;
        }

        try {
            await signInWithEmailAndPassword(auth, email, password);
            navigate('/dashboard');
        } catch(error) {
            console.log(error)
            cambiarEstadoAlerta(true);
            let mensaje;
            switch(error.code){
                case 'auth/invalid-credential':
                    mensaje = 'La contraseña o correo electrónico no son correcta.'
                    break;
                case 'auth/user-not-found':
                    mensaje = 'No se encontro ninguna cuenta con este correo electrónico.'
                    break;
                default:
                    mensaje = 'Hubo un error al intentar iniciar sesión.'
                break;
            }

            cambiarAlerta({tipo: 'error', mensaje: mensaje});
        }
    }

  return (
    <Box component="main" maxWidth="xs" sx={{ flexDirection: 'row',  width: '100%', height: '100%', padding: '10%', justifyContent: 'center' }}>
        <Box
            sx={{
                marginTop: 8,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
            }}
        >
            <Typography component="h1" variant="h5">
                Iniciar Sesión
            </Typography>

            {/* Formulario de Login */}
            <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1 }}>
                {/* Campo de correo electrónico */}
                <TextField
                    margin="normal"
                    required
                    fullWidth
                    id="email"
                    label="Correo Electrónico"
                    name="email"
                    autoComplete="email"
                    autoFocus
                    value={email}
                    size='small'
                    onChange={handleChange}
                />

                {/* Campo de contraseña */}
                <TextField
                    margin="normal"
                    required
                    fullWidth
                    name="password"
                    label="Contraseña"
                    type="password"
                    id="password"
                    size='small'
                    autoComplete="current-password"
                    value={password}
                    onChange={handleChange}
                />

                {/* Botón de Iniciar Sesión */}
                <Button
                    type="submit"
                    fullWidth
                    size='small'
                    color='#5d0303'
                    variant="outlined"
                    sx={{ mt: 3, mb: 2 }}
                >
                    Iniciar Sesión
                </Button>

                {/* Enlace de recuperación de contraseña */}
                {/*<Link href="#" variant="body2" sx={{ display: 'block', textAlign: 'center', mt: 2 }}>
                    ¿Olvidaste tu contraseña?
                </Link>
                <Link href="/register" variant="body2" sx={{ display: 'block', textAlign: 'center', mt: 1 }}>
                    ¿No tienes una cuenta? Regístrate
                </Link>*/}
            </Box>
        </Box>
        <Alerta 
            tipo={alerta.tipo}
            mensaje={alerta.mensaje}
            estadoAlerta={estadoAlerta}
            setAlerta={cambiarAlerta}
        /> 
    </Box>
  );
};

export default Login;